import { MutationTree } from 'vuex';
import { BusinessSystemState, BusinessSystem } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

// エラーをクリアする
const resetErrors = (state: BusinessSystemState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const createState = state.create;
    createState.error = false;
    createState.errorTitle = undefined;
    createState.errorDetails = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const updateState = state.update;
    updateState.error = false;
    updateState.errorTitle = undefined;
    updateState.errorDetails = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;
};

export const mutations: MutationTree<BusinessSystemState> = {
    // 業務システム検索系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; business_systems: Array<BusinessSystem> }) {
        state.businessSystemCount = payload.count;
        state.businessSystems = payload.business_systems;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // 業務システム作成系
    [types.CLEAR_ERROR_BUSINESS_SYSTEM](state) {
        resetErrors(state);
        const createState = state.create;
        createState.isCreated = false;
    },

    [types.CREATE_START](state) {
        resetErrors(state);
        const createState = state.create;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
        createState.isCreated = true;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // 業務システム詳細情報参照系
    [types.SHOW_START](state) {
        resetErrors(state);
        const showState = state.show;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: { business_system: BusinessSystem }) {
        const showState = state.show;
        state.businessSystemDetails.businessSystem = payload.business_system;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // 業務システム更新系
    [types.UPDATE_START](state) {
        resetErrors(state);
        const updateState = state.update;
        updateState.isProcessing = true;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // 業務システム削除系
    [types.DESTROY_START](state) {
        resetErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const createState = state.create;
        createState.isProcessing = false;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const updateState = state.update;
        updateState.isProcessing = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.businessSystems = undefined;
        state.businessSystemCount = 0;
        state.businessSystemDetails.businessSystem = undefined;
    },
};
